var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"payment-card"},[(_vm.showTabs())?_c('tabs',{attrs:{"tabs":_vm.tabs},on:{"change":_vm.onChange},model:{value:(_vm.selectedTab),callback:function ($$v) {_vm.selectedTab=$$v},expression:"selectedTab"}}):_vm._e(),_c('rows',{attrs:{"config":_vm.data,"trans":_vm.trans}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }